/**
 * Created by shubham on 24/11/18.
 */

import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { DialogComponent } from '../../../dialog/dialog.component';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { BusinessUnitListPage } from "../businessUnitList-datatable/businessUnitList-page";
import { APPCONFIG } from '../../../config';
import { BusinessUnitListForUserDashboardResultService } from '../businessUnitForUserDashboardResultService';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'businessUnitList',
    template: require('./business-unit-list.component.html')
})
export class BusinessUnitListForUserComponent {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    dialogRef;
    userDetails:any;
    page = new BusinessUnitListPage();
    tableRows :any = [];
    filters:any = {};
    rows:any;
    businessUnitListData = [];
    temp = [];
    showTable:boolean = true;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    selected = [];
    businessUnitForUserListText: any;
    ApplicationData = [];
    selectedApplicationId: string = '';
    selectedStatusId: boolean;
    profileData: any;
    businessUnitWithApplicationAndRoles = [];
    businessUnitWithAppRolesProfile = [];

    constructor(private router: Router, private httpService:HttpService, private sessionHandler:SessionHandler, public dialog: MdDialog,
                private formBuilder: FormBuilder, private serverResultsService: BusinessUnitListForUserDashboardResultService, 
                private commonService: CommonService, private translate: TranslateService) {

        this.businessUnitForUserListText = 'businessUnitForUserList';

        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if(this.isServiceOwner){
            //this.getApplications();
            //this.getUsersList(this.filters, this.selectedApplicationId);
            this.getPartnersProfileData();
        } else{
            //this.getUserList();
        }
    }

    public getPartnersProfileData(){
        this.httpService.getRequest('partnerOperationsApi/v1/partnerDetails').subscribe(
            res => { this.savePartnersProfileData(res) },
            err => { this.httpService.onEnd(); }
        );
    }

    public savePartnersProfileData(res) {
        if(res){
            this.profileData = res;
            if(this.profileData){
                if(this.profileData.businessUnitWithApplicationAndRoles){
                    this.businessUnitWithApplicationAndRoles = this.profileData.businessUnitWithApplicationAndRoles;

                    for(let businessUnit in this.businessUnitWithApplicationAndRoles) {
                        for(let appAndRoles in this.businessUnitWithApplicationAndRoles[businessUnit]['applications']){
                            let temp = [];
                            temp['businessUnitName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['businessUnitName'];
                            temp['customerNumber'] = this.businessUnitWithApplicationAndRoles[businessUnit]['customerNumber'];
                            temp['applicationName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['applicationName'];
                            temp['selectedRoleNames'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['selectedRoleNames'];
                            temp['url'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['url'];

                            let actionObject = {};
                            if( this.businessUnitWithApplicationAndRoles[businessUnit]['statusCode'] != 'APPROVED' ){
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit];
                            } else {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles];
                            }
                            temp['statusCode'] = actionObject['statusCode'];
                            temp['status'] = actionObject['status'];
                            temp['message'] = actionObject['message'];

                            this.businessUnitWithAppRolesProfile.push(temp);
                        }
                    }
                }
            }
            this.httpService.onEnd();
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    }

    public getApplications() {
        this.httpService.getRequest('applicationOperationApi/v1/applicationsForPartner').subscribe(
            res => { this.saveApplications(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    saveApplications(res) {
        if(res && res.items){
            for(let s in res.items){
                this.ApplicationData.push(res.items[s]);
            }
        }
    }

    public search(){
        this.filters['offSet'] = 0;
        this.getUsersList(this.filters, this.selectedApplicationId);
    }

    public resetSearch(){
        this.selectedApplicationId = "";
        this.search();
    }

    public getUsersList(filter, applicationId){
        this.httpService.getRequest("partnerOperationsApi/v1/businessUnitListForPartner?limit="+filter.limit+"&offset="+filter.offSet+"&applicationId="+applicationId).subscribe(
            res => { this.saveUserList(res,filter); },
            err => { this.httpService.onEnd();}
        );
    }

    public getUserList = function () {
        this.showTable = false;
    }

    public saveUserList = function(res, filter){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if(res && Object.keys(res).length > 0 ){
                this.businessUnitListData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;

                if(this.businessUnitListData.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.businessUnitListData.list) {
                        if(this.isServiceOwner){
                            this.rows[data] = {};
                            this.rows[data]['countryId'] = this.businessUnitListData.list[data]['countryId'];
                            this.rows[data]['countryName'] = this.businessUnitListData.list[data]['countryName'];
                            this.rows[data]['businessUnitId'] = this.businessUnitListData.list[data]['businessUnitId'];
                            this.rows[data]['businessUnitName'] = this.businessUnitListData.list[data]['businessUnitName'];
                            this.rows[data]['emailVerified'] = this.businessUnitListData.list[data]['emailVerified'];
                            this.rows[data]['customerNumber'] = this.businessUnitListData.list[data]['customerNumber'];

                            if(this.businessUnitListData.list[data]['selectedApplicationNames']){
                                this.rows[data]['selectedApplicationNames'] = this.businessUnitListData.list[data]['selectedApplicationNames'];
                            }

                            this.rows[data]['status'] = this.businessUnitListData.list[data]['status'];
                            this.rows[data]['active'] = this.businessUnitListData.list[data]['active'];
                        } else{
                            //For Other Service Partner's
                            this.rows[data] = {};
                        }
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else{
                    this.showTable = false;
                }

                let finalRows = [];
                for(let f in this.rows){
                    if(f != 'offset' && f !='totalCount' && this.rows[f]){
                        finalRows.push(this.rows[f]);
                    }
                    if(f == 'offset'){
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if(f == 'totalCount'){
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset']/this.page.size },finalRows,filter);
                this.httpService.onEnd();
            }
        }
    }

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo,rows,filter){
        this.page.pageNumber = pageInfo.offset;
        if(rows.length != 0){
            this.serverResultsService.getResults(this.page,rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if(!filter){
                    if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getUsersList(this.filters, this.selectedApplicationId);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }

    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }

    ngOnInit() {
        var temp = [{id:"",code:"",name: "All"}];
        this.translate.get('all').subscribe((res: string) => {temp[0].name = res;
            this.ApplicationData = temp;
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/business-unit-list/business-unit-list.component.ts